import { Link } from 'react-router-dom';
import { reports } from '@/mocks/reports';
import ReportCard from '@/components/base/ReportCard';

export default function FeaturedReports() {
  const featured = reports.filter((r) => r.isFeatured).slice(0, 3);
  const rest = reports.filter((r) => !r.isFeatured).slice(0, 4);

  return (
    <section className="bg-background-50 py-14 md:py-20" aria-labelledby="featured-heading">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        {/* Section header */}
        <div className="flex items-center justify-between mb-8">
          <h2 id="featured-heading" className="headline-divider font-heading text-xl md:text-2xl font-bold text-foreground-950">
            近期核实报道
          </h2>
          <Link
            to="/reports"
            className="text-xs text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {/* Featured grid: 1 large + 2 smaller */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-6">
          <div className="lg:col-span-2">
            {featured[0] && <ReportCard report={featured[0]} variant="featured" />}
          </div>
          <div className="flex flex-col gap-4">
            {featured.slice(1, 3).map((r) => (
              <ReportCard key={r.id} report={r} variant="featured" />
            ))}
          </div>
        </div>

        {/* Regular grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {rest.map((r) => (
            <ReportCard key={r.id} report={r} variant="default" />
          ))}
        </div>
      </div>
    </section>
  );
}